import './TourAverages.scss';
import '../Admin.scss';
import '../../../styles/_table.scss';

import AdminEditWarning from 'components/Admin/AdminEditWarning/AdminEditWarning';
import { Button } from '@trackman/web-shared-components';
import TourAveragesTable from 'components/Admin/TourAverages/TourAveragesTable/TourAveragesTable';
import TourAveragesTableToolbar from 'components/Admin/TourAverages/TourAveragesTableToolbar/TourAveragesTableToolbar';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import useSetPageTitle from 'utilities/useSetPageTitle';
import { useStores } from 'index';

export const TourAverages = observer(() => {
  useSetPageTitle({ title: 'Tour Averages tables', subtitle: '' });
  const ta = useStores().tourAverageEditorStore;
  const ps = useStores().parametersStore;

  useEffect(() => {
    ps.getParameters();
  }, [ps]);

  useEffect(() => {
    ta.getTourAverages();
  }, [ta]);

  useEffect(() => {
    ps.filteredPGAList = ps.parametersList.filter((parameter) => {
      return !ta.tourAveragesData.pga.some((pgaParameter) => pgaParameter.parameterId === parameter.id);
    });
  }, [ta.tourAveragesData, ps, ps.parametersList]);

  const handleDeleteColumn = (index: number) => {
    ta.tourAveragesData.pga.splice(index, 1);
    ta.tourAveragesData.lpga.splice(index, 1);
    ps.filteredPGAList = ps.parametersList.filter((parameter) => {
      return !ta.tourAveragesData.pga.some((TAparameter) => TAparameter.parameterId === parameter.id);
    });
  };

  return (
    <div className='admin-content-container'>
      <AdminEditWarning />
      <TourAveragesTableToolbar />
      <TourAveragesTable kind='PGA' tourAveragesScoresArray={ta.tourAveragesData.pga} handleDeleteColumn={handleDeleteColumn} />
      <TourAveragesTable kind='LPGA' tourAveragesScoresArray={ta.tourAveragesData.lpga} handleDeleteColumn={handleDeleteColumn} />
      <Button
        className='styled-button primary save-pga-tables'
        intent='primary'
        isLoading={ta.isLoading}
        onClick={() => {
          if (ta.tourAveragesData.id !== '') {
            ta.updateTourAveragesAndRefreshTable();
          } else {
            ta.saveNewTourAveragesAndRefreshTable();
          }
        }}
      >
        Save tables
      </Button>
    </div>
  );
});

export default TourAverages;
